import { Component, Input, OnInit, Renderer2, OnChanges } from "@angular/core";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { InvoiceProposalDto } from "../../../core/models/invoice-preview/invoiceProposalDto";
import { OrderNotes } from "../../../core/models/invoice-preview/orderNotes";
import {
  debounceTime,
  distinctUntilChanged,
  EMPTY,
  Subject,
  switchMap,
} from "rxjs";
import { ProposalListRequestDto } from "../../../core/models/invoice-preview/proposalListRequestDto";
import { DateFilter } from "../../../core/models/common/date-filter-request.dto";
import { ProjectInvoiceReportSalesInvoiceList } from "../../../core/models/orders/getProjectInvoiceReportSalesResponseDto";
import { InvoicePreviewSummaryService } from "../../../core/services/invoice-preview-summary.service";
import { LoaderService } from "../../../core/services/loader.service";
import { OrderListingPaginatedService } from "../../../core/services/order-listing-paginated.service";
import {
  SharedService,
  exportExcel,
} from "../../../core/services/shared.service";
import { JniToastrService } from "../../../core/services/jni-toastr.service";
import { TableLazyLoadEvent, TableModule } from "primeng/table";
import { CommonModule } from "@angular/common";
import { DateFilterComponent } from "../../../shared/components/date-filter/date-filter.component";
import { HidedynamicsdatePipe } from "../../../shared/pipes/hidedate/hidedynamicsdate.pipe";
import { ModalStackerComponent } from "../../../shared/components/modal-stacker/modal-stacker.component";
import { InvoicePreviewSummaryComponent } from "../invoice-preview-summary/invoice-preview-summary.component";
import { InvoicePreviewOrderNotesComponent } from "../invoice-preview-order-notes/invoice-preview-order-notes.component";
import { ClientDetailsComponent } from "../../clients/components/client-details/client-details.component";
import { OrderSummaryComponent } from "../../orders/components/order-summary/order-summary.component";
import { InvoicePdfDialogueComponent } from "../../orders/components/invoice-pdf-dialogue/invoice-pdf-dialogue.component";
import { RadioButtonClickEvent, RadioButtonModule } from "primeng/radiobutton";
import { FilterMetadata } from "primeng/api";

import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { InputTextModule } from "primeng/inputtext";
import { GenericFilterRequestDto } from "../../../core/models/generic-filter-request.dto";
import { GenericSortRequestDto } from "../../../core/models/generic-sort-request.dto";
import { FormsModule } from "@angular/forms";

@UntilDestroy()
@Component({
  selector: "jni-invoice-preview-listing-paginated",
  templateUrl: "./invoice-preview-listing-paginated.component.html",
  styleUrls: ["./invoice-preview-listing-paginated.component.scss"],
  imports: [
    TableModule,
    CommonModule,
    DateFilterComponent,
    HidedynamicsdatePipe,
    ModalStackerComponent,
    InvoicePreviewSummaryComponent,
    InvoicePreviewOrderNotesComponent,
    ClientDetailsComponent,
    OrderSummaryComponent,
    InvoicePdfDialogueComponent,
    RadioButtonModule,
    ButtonModule,
    CardModule,
    InputTextModule,
    FormsModule,
  ],
})
export class InvoicePreviewListingPaginatedComponent
  implements OnInit, OnChanges
{
  @Input() inovicePreviewDisplayModal = false;

  invoicePreviewList: InvoiceProposalDto[] = [];
  invoicePreviewSummaryDisplayModal = false;
  invoicePreviewNumber = "";
  saleOrderId = "";
  saleOrderIdModal = "";
  invoicePreviewListingModalStatus = false;
  orderNotesGridListing: OrderNotes[] = [];
  defaultTake = 50;
  totalRecords = 0;
  lazyLoadEvent!: TableLazyLoadEvent;
  public orderBilling$ = new Subject<string>();
  filterTextChanged: Subject<Event | InvoiceProposalDto[] | DateFilter> =
    new Subject<Event | InvoiceProposalDto[] | DateFilter>();
  filterDebounceTime = 1000;
  clientDisplayModal = false;
  orderDisplayModal = false;
  customerId = "";
  selectedRadioButton = "Open";

  invoicePdfDialogue = false;
  invoiceList: ProjectInvoiceReportSalesInvoiceList[] = [];

  invoiceDateFilter = {} as DateFilter;
  dateFieldName = "ipCreatedDateD365";
  filterMode = "server";

  constructor(
    private _invoicePreviewSummaryService: InvoicePreviewSummaryService,
    private _loaderService: LoaderService,
    private renderer: Renderer2,
    private _orderListingPaginatedService: OrderListingPaginatedService,
    private _toastr: JniToastrService,
    private _sharedService: SharedService
  ) {}

  ngOnInit(): void {
    this.getOrderBilling();
  }

  ngOnChanges() {
    if (this.inovicePreviewDisplayModal) {
      this.invoicePreviewListingModalStatus = true;
    }
  }

  exportExcel() {
    exportExcel(this.invoicePreviewList, "Invoice Preview");
  }

  onHoverBillingComments(invoiceProposalId: string, billingComment: string) {
    this.orderNotesGridListing = [];
    if (invoiceProposalId && billingComment) {
      this.orderBilling$.next(invoiceProposalId);
    }
  }

  getAllInvoicePreviewListingData(event: TableLazyLoadEvent) {
    this.lazyLoadEvent = event;
    if (event) {
      const eventFilterArray = Object.keys(
        event.filters ?? ({} as FilterMetadata | FilterMetadata[])
      );
      const filter: GenericFilterRequestDto[] = eventFilterArray.map(x => {
        const filterData = event?.filters?.[x] as FilterMetadata;
        return {
          columnName: x || "",
          matchMode: filterData?.matchMode ?? "",
          tableName: "",
          value: filterData?.value ?? "",
        } as GenericFilterRequestDto;
      });

      const sortArray: GenericSortRequestDto[] =
        event.multiSortMeta?.map(x => {
          return {
            ...x,
          } as GenericSortRequestDto;
        }) ?? [];

      filter.forEach(x => {
        if (x.columnName == "invoicePreviewNumber") {
          x.columnName = "ProposalIdD365";
          x.tableName = "ProjectInvoiceProposal";
        }

        const ipCreatedDateD365 =
          this._sharedService.convertDateFormat(
            this.invoiceDateFilter.startDate ?? ""
          ) +
          "|" +
          this._sharedService.convertDateFormat(
            this.invoiceDateFilter.endDate ?? ""
          );

        if (x.columnName == "ipCreatedDateD365") {
          x.columnName = "IpCreatedDateD365";
          x.matchMode = this.invoiceDateFilter.selectedMatchMode;
          x.tableName = "ProjectInvoiceProposal";
          x.value = ipCreatedDateD365;
        }
        if (x.columnName == "customerName") {
          x.columnName = "CustomerNameD365";
          x.tableName = "ProjectInvoiceProposal";
        }
        if (x.columnName == "customerNumber") {
          x.columnName = "CustomerAccountD365";
          x.tableName = "ProjectInvoiceProposal";
        }
        if (x.columnName == "orderNumber") {
          x.columnName = "SalesOrderIdD365";
          x.tableName = "ProjectInvoiceProposal";
        }
        if (x.columnName == "previewStatus") {
          if ((x.value! as string).toLowerCase().startsWith("i")) {
            x.columnName = "LinePropertyD365";
            x.tableName = "ProjectInvoiceProposal";
          } else if (
            x.value &&
            "canceled".includes((x.value as string).toLowerCase())
          ) {
            x.columnName = "LinePropertyD365";
            x.tableName = "ProjectInvoiceProposal";
          } else {
            x.columnName = "PreviewStatusD365";
            x.tableName = "ProjectInvoiceProposal";
          }
        }
      });
      const request: ProposalListRequestDto = {
        skip: event.first ?? 0,
        take: event.rows ?? this.defaultTake,
        filters: filter,
        sort: sortArray,
        status: this.selectedRadioButton,
      };
      this._loaderService.setLoaderState(true);
      this._invoicePreviewSummaryService
        .getInvoicePreviewListingPaginated(request)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this._loaderService.setLoaderState(false);
            if (res.data) {
              this.invoicePreviewList = res.data;
              this.totalRecords = res.totalRecords ?? 0;
            }
          },
          error: () => {
            this._loaderService.setLoaderState(false);
          },
        });
    }
  }

  getOrderBilling() {
    this.orderBilling$
      .pipe(
        debounceTime(200),
        switchMap((invoiceProposalId: string) => {
          if (invoiceProposalId) {
            return this._invoicePreviewSummaryService.getSalesOrderNotesWithTypeInvoiceProposal(
              invoiceProposalId
            );
          }
          return EMPTY;
        })
      )
      .subscribe({
        next: res => {
          if (res.data) {
            if (res?.data?.length > 0) {
              const billingNotes = res.data.filter(x =>
                x?.type?.toLowerCase()?.includes("proposal")
              );
              this.orderNotesGridListing = billingNotes;
            }
          }
        },
        error: () => {
          this._loaderService.setLoaderState(false);
        },
      });
  }

  openInvoice(invoicePreviewNumber: string, saleOrderId: string) {
    this.invoicePreviewNumber = invoicePreviewNumber;
    this.saleOrderId = saleOrderId;
    this.invoicePreviewSummaryDisplayModal = true;
  }

  closeModalForInvoicePreview() {
    this.invoicePreviewSummaryDisplayModal = false;
  }

  addScollHiddenClass() {
    if (this.invoicePreviewListingModalStatus) {
      this.renderer.addClass(document.body, "p-overflow-hidden");
    } else {
      this.renderer.removeClass(document.body, "p-overflow-hidden");
    }
  }

  scrollHiddenStatus() {
    setTimeout(() => {
      this.renderer.removeClass(document.body, "p-overflow-hidden");
    }, 0);
  }

  orderNotesDisplayModal = false;
  orderNotesDisplayModalFunction(status: boolean) {
    this.orderNotesDisplayModal = status;
  }

  closeModalForOrderNotes() {
    this.orderNotesDisplayModal = false;
  }

  onFilterInput($event: Event | InvoiceProposalDto[] | DateFilter, value = "") {
    if (value === "clear") {
      this.clearFilter();
    }

    if ("startDate" in $event && $event.startDate) {
      this.invoiceDateFilter = $event;
    }

    if (this.filterTextChanged.observers.length === 0) {
      this.filterTextChanged
        .pipe(debounceTime(this.filterDebounceTime), distinctUntilChanged())
        .subscribe(() => {
          this.getAllInvoicePreviewListingData(this.lazyLoadEvent);
        });
    }
    this.filterTextChanged.next($event);
  }

  closeClientModal() {
    this.clientDisplayModal = false;
  }

  closeModalForSaleOrder() {
    this.orderDisplayModal = false;
  }

  redirectToClientSummary(customerId: string) {
    if (customerId) {
      this.customerId = customerId;
      this.clientDisplayModal = true;
    }
  }

  redirectToSummary(saleOrderId: string) {
    if (saleOrderId) {
      this.saleOrderIdModal = saleOrderId;
      this.orderDisplayModal = true;
    }
  }

  getOrderOnChange(value: RadioButtonClickEvent) {
    if (value.value == "Approved") {
      this.selectedRadioButton = "Approve";
    } else {
      this.selectedRadioButton = value.value;
    }

    this.getAllInvoicePreviewListingData(this.lazyLoadEvent);
  }

  onStatusClick(salesOrderId: string) {
    if (salesOrderId) {
      this._loaderService.setLoaderState(true);
      this._orderListingPaginatedService
        .getProjectInvoiceReportSales({
          SalesOrderId: salesOrderId,
        })
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            if (res?.status?.toLowerCase() == "success") {
              if (res.data) {
                if (res.data.InvoiceCount == 1) {
                  this._loaderService.setLoaderState(true);
                  this._orderListingPaginatedService
                    .getProjectInvoiceReport({
                      InvoiceDate: res.data.InvoiceList[0]?.InvoiceDate ?? "",
                      ProjectInvoiceId:
                        res.data.InvoiceList[0]?.ProjectInvoiceId,
                    })
                    .pipe(untilDestroyed(this))
                    .subscribe({
                      next: res => {
                        this._loaderService.setLoaderState(false);
                        if (res.data?.reportBase64String) {
                          const blob = this.b64toBlob(
                            res.data.reportBase64String,
                            "application/pdf"
                          );
                          const blobUrl = URL.createObjectURL(blob);
                          window.open(blobUrl);
                        } else {
                          this._toastr.error(
                            "Error",
                            res.message || "Failed To Fetch Invoice PDF"
                          );
                        }
                      },
                      error: () => {
                        this._loaderService.setLoaderState(false);
                        this._toastr.error(
                          "Error",
                          "Failed To Fetch Invoice PDF"
                        );
                      },
                    });
                } else if (res.data.InvoiceCount > 1) {
                  this._loaderService.setLoaderState(false);
                  this.invoiceList = res.data.InvoiceList;
                  this.invoicePdfDialogue = true;
                } else {
                  this._loaderService.setLoaderState(false);
                  this._toastr.error(
                    "Error",
                    res.message || "Failed To Fetch Invoice PDF"
                  );
                }
              } else {
                this._loaderService.setLoaderState(false);
                this._toastr.error(
                  "Error",
                  res.message || "Failed To Fetch Invoice PDF"
                );
              }
            } else {
              this._loaderService.setLoaderState(false);
              this._toastr.error(
                "Error",
                res.message || "Failed To Fetch Invoice PDF"
              );
            }
          },
          error: () => {
            this._loaderService.setLoaderState(false);
            this._toastr.error("Error", "Failed To Fetch Invoice PDF");
          },
        });
    }
  }

  b64toBlob(b64Data: string, contentType = "", sliceSize = 512) {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  closeUrlDialog() {
    this.invoicePdfDialogue = false;
  }

  clearFilter() {
    this.invoiceDateFilter = {} as DateFilter;
  }
}
